import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is a `smart` component. It will render the correct variant for the identified user.
 * To utilize, simply pass in the experiment ID as props, and pass the variant ID associated
 * with each child as props to that child. If no children match the variant, the first child given
 * will be used as the default.

  Example usage:
  <AB experimentID='my-cool-experiment'>
    <Categories variantName='Control' />
    <Categories variantName='blue' color='blue'/>
  </AB>
  */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AB from './component';
import { activateExperiment, deactivateExperiment, eeeReported } from './actions';

var ABContainer = /*#__PURE__*/function (_Component) {
  _inherits(ABContainer, _Component);

  function ABContainer() {
    _classCallCheck(this, ABContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ABContainer).apply(this, arguments));
  }

  _createClass(ABContainer, [{
    key: "componentWillMount",
    // eslint-disable-next-line react/no-deprecated
    value: function componentWillMount() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      if (!this.props.experiments && process.env.NODE_ENV === 'development') {
        console.error('`experiments` reducer not found.' + 'Make sure to import the reducer and add to your redux store');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          experiments = _this$props.experiments,
          props = _objectWithoutProperties(_this$props, ["experiments"]);

      return React.createElement(AB, _extends({}, props, experiments));
    }
  }]);

  return ABContainer;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


ABContainer.displayName = 'AB Container'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ABContainer.propTypes = {
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  experimentID: PropTypes.string,
  activateExperiment: PropTypes.func.isRequired,
  deactivateExperiment: PropTypes.func.isRequired,
  eeeReported: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  experiments: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    availableExperiments: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    currentlyActiveExperiments: PropTypes.object
  }).isRequired
};
export default connect(function (state, ownProps) {
  var active = state.experiments.currentlyActiveExperiments;
  return {
    experiments: state.experiments,
    hasBeenTracked: active && !!active[ownProps.experimentID]
  };
}, {
  activateExperiment: activateExperiment,
  deactivateExperiment: deactivateExperiment,
  eeeReported: eeeReported
})(ABContainer);